"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSagas = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _saga = require("./utils/saga");

var withSagas = function withSagas(sagas) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      (0, _inherits2["default"])(_class, _Component);

      function _class() {
        var _getPrototypeOf2;

        var _this;

        (0, _classCallCheck2["default"])(this, _class);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));
        _this.sagaTasks = [];

        _this.getProps = function () {
          return _this.props;
        };

        return _this;
      }

      (0, _createClass2["default"])(_class, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.sagaTasks = (0, _ramda.map)(function (saga) {
            return (0, _saga.runSaga)(_this2.context.sagaMiddleware, saga, _this2.getProps);
          }, sagas);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          (0, _ramda.forEach)(function (task) {
            return task.cancel();
          }, this.sagaTasks);
        }
      }, {
        key: "render",
        value: function render() {
          return _react["default"].createElement(WrappedComponent, this.props);
        }
      }]);
      return _class;
    }(_react.Component), _class.contextTypes = {
      sagaMiddleware: _propTypes["default"].func.isRequired
    }, _temp;
  };
};

exports.withSagas = withSagas;